import { TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";

const headerCellStyle = {
  fontSize: "13px",
  whiteSpace: "nowrap",
  py: 1,
  backgroundColor: "#ececec",
};

const headerRowStyle = {
  backgroundColor: "rgba(64, 64, 64, 0.1)",
};

function TableHeader1({ tableData, page }) {
  return (
    <>
      <TableHead>
        <TableRow sx={headerRowStyle}>
          {tableData.columns.map((column, index) => (
            <TableCell
              key={index}
              sx={{
                ...headerCellStyle,
                textAlign: index === 0 ? "left" : "center",
              }}
            >
              {column}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}

export default TableHeader1;
